import {Component, OnInit, EventEmitter, Output} from '@angular/core';
import {PortfolioService} from "./portfolio.service";
import {PortfolioItem} from "./portfolio-item";
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-partfolio-gallery',
  templateUrl: './portfolio-gallery.component.html',
  styleUrls: ['./portfolio-gallery.component.css'],
  providers: [ PortfolioService]
})
export class PartfolioGalleryComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.703;
  item: PortfolioItem;


  constructor(
    private portfolioService: PortfolioService,
    private service: GlobalServiceService
  ) { }

  ngOnInit() {
    this.onResize();
  }

  onResize() {
    this.height = this.service.getHeight(this.proportion);
 }


 onSelected(id: number) {
   this.portfolioService.setPortfolioItem(id);
 }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio-gallery.component.ts